

// import React, { useState, useEffect } from 'react';
// import { Helmet } from 'react-helmet';
// import './nav.css';
// import { HiOutlineShoppingBag } from "react-icons/hi2";
// import { FaRegHeart, FaRegUser } from "react-icons/fa";
// import { IoChevronDown, IoChevronUp } from "react-icons/io5";
// import ShoppingCartPopup from '../Popup/popupcard';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useSelector, useDispatch } from "react-redux";
// import { getWithoutTokenAPI, getWithTokenAPI } from '../../util/Api';
// import { setWishlistCount, setWishlistItems } from '../../store/wishlistSlice';
// import { setTotalItems } from '../../store/cartSlice';

// // Local category icons
// import furit from '../../assets/navbar/apple.svg';
// import Vegetables from '../../assets/navbar/salad 1.svg';
// import fish from '../../assets/navbar/fish.svg';
// import chicken from '../../assets/navbar/meat.svg';
// import drink from '../../assets/navbar/coffee.svg';
// import ice from '../../assets/navbar/ice-cream.svg';
// import cake from '../../assets/navbar/cupcake.svg';
// import butter from '../../assets/navbar/pie.svg';
// import cook from '../../assets/navbar/food.svg';
// import plus from '../../assets/navbar/plus-solid.svg';
// // import { useCart } from '../../Context/cart';
// import { Link } from "react-router-dom"
// import { TbLogin2 } from "react-icons/tb";

// const localCategoryImages = {
//   'Fresh Fruit': furit,
//   'Vegetables': Vegetables,
//   'River Fish': fish,
//   'Chicken & Meat': chicken,
//   'Drink & Water': drink,
//   'Yogurt & Ice Cream': ice,
//   'Cake & Bread': cake,
//   'Butter & Cream': butter,
//   'Cooking': cook,
//   'More': plus,
// };

// const getPageTitle = (pathname) => {
//   switch (pathname) {
//     case '/':
//       return 'MarketPlace'; // Changed from 'Home' to 'Market Place'
//     case '/shop':
//       return 'Shop';
//     case '/blog':
//       return 'Blog';
//     case '/about':
//       return 'About Us';
//     case '/contact':
//       return 'Contact Us';
//     case '/privacy':
//       return 'Privacy Policy';
//     case '/terms':
//       return 'Terms & Conditions';
//     case '/faq':
//       return 'FAQ';
//     default:
//       return 'Shambasync';
//   }
// };

// const NavLinks = ({ total }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [categoriesOpen, setCategoriesOpen] = useState(false);
//   const [cartVisible, setCartVisible] = useState(false);
//   const dispatch = useDispatch();
//   const userId = useSelector((state) => state.auth?.auth?._id);
//   const wishlistCount = useSelector((state) => state.wishlist.totalCount);
//   const totalItems = useSelector((state) => state.cart.totalItems || 0);
//   const username = useSelector((state) => state.auth?.auth?.name || '');
//   const accessToken = useSelector((state) => state.auth?.auth?.access_token);

//   const [categories, setCategories] = useState([]);
//   const isActive = (path) => location.pathname === path;

//   const shouldShowDropdown = ['/shop', '/blog', '/about', '/contact', '/product', '/user', '/blog/find-particular', '/whish', '/Shopping_Cart'].includes(location.pathname);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     if (menuOpen && isMobile) {
//       document.body.classList.add('scroll');
//     } else {
//       document.body.classList.remove('no-scroll');
//     }
//   }, [menuOpen, isMobile]);

//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//     if (!menuOpen) {
//       setCategoriesOpen(false);
//     }
//   };

//   const toggleCategories = () => {
//     if (shouldShowDropdown) {
//       setCategoriesOpen(!categoriesOpen);
//     }
//   };

//   const navigateTo = (path) => {
//     navigate(path);
//     setMenuOpen(false);
//   };

//   const toggleCart = () => setCartVisible(!cartVisible);
//   const closeCart = () => setCartVisible(false);

//   useEffect(() => {
//     const fetchCategories = async () => {
//       const result = await getWithoutTokenAPI("/category/find-all?Approval_status=Approval");
//       if (result && !result.error && result.data?.categories) {
//         const dataWithImages = result.data.categories.map((cat) => ({
//           id: cat._id,
//           name: cat.category_name,
//           image: cat.image || localCategoryImages[cat.category_name] || plus,
//         }));
//         setCategories(dataWithImages);
//       }
//     };
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     const fetchWishlistCount = async () => {
//       if (!userId) return;

//       try {
//         const response = await getWithTokenAPI(accessToken, `/wishlist/find-all?user_id=${userId}`);
//         if (response?.statusCode === 200) {
//           dispatch(setWishlistCount(response.data.total_count));
//           dispatch(setWishlistItems(response.data.wishlist));
//         }
//       } catch (error) {
//         console.error('Error fetching wishlist:', error);
//       }
//     };

//     fetchWishlistCount();
//   }, [userId, dispatch]);

//   useEffect(() => {
//     const fetchCartCount = async () => {
//       if (!userId || !accessToken) return;
//       try {
//         const response = await getWithTokenAPI(accessToken, `/cart/find-all?user_id=${userId}`);

//         if (response?.statusCode === 200 && response.data) {
//           dispatch(setTotalItems(response.data?.Cart[0]?.cart?.length));
//           console.log(response.data,'totallcarttt')
//         }
//       } catch (error) {
//         console.error('Error fetching cart count:', error);
//       }
//     };

//     fetchCartCount();
//   }, [userId, dispatch, accessToken]);

//   const handleCategoryClick = (category) => {
//     navigate(
//       `/shop?category_id=${category.id}&category_name=${encodeURIComponent(category.name)}`,
//       {
//         state: {
//           selectedCategoryId: category.id,
//           selectedCategoryName: category.name
//         }
//       }
//     );
//     setMenuOpen(false);
//     setCategoriesOpen(false);
//   };

//   return (
//     <>
//       {location.pathname === '/' ? (
//         <Helmet>
//           <title>MarketPlace</title> {/* Changed title here */}
//           <meta name="description" content="Welcome to Shambasync - your go-to store for fresh food and more!" />
//         </Helmet>
//       ) : (
//         <Helmet>
//           <title>{`${getPageTitle(location.pathname)}`}</title>
//           <meta name="description" content={`${getPageTitle(location.pathname)} page of Shambasync`} />
//         </Helmet>
//       )}
//       <div className={`nav-bar-container ${location.pathname === '/' ? 'home-page' : ''}`}>
//         {/* Mobile Hamburger Button */}
//         <button className="mobile-menu-button" onClick={toggleMenu}>
//           <div className="hamburger-icon">
//             <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
//             <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
//             <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
//           </div>
//         </button>

//         {/* Mobile Menu Content */}
//         {menuOpen && (
//           <div className="mobile-menu-content">
//             <div className="mobile-nav-links">
//               {['/', '/shop', '/blog', '/about', '/contact'].map((path) => (
//                 <div key={path} className="mobile-nav-item" onClick={() => navigateTo(path)}>
//                   <span className={`text-light ${isActive(path) ? 'active' : ''}`}>
//                     {path === '/' ? 'MarketPlace' : path.replace('/', '').charAt(0).toUpperCase() + path.slice(2)} {/* Changed "Home" to "Market Place" */}
//                   </span>
//                 </div>
//               ))}

//               {!accessToken && (<div className='navlogincontainer'>
//                 <Link id='navloginbutton' style={{fontSize:"16px"}} className={`nav-bar-text  ${isActive("/login") ? 'active' : 'inactive'}`} to="/login">
//                   <TbLogin2 /> Login
//                 </Link>
//               </div>)
//               }


//               <div className="mobile-categories-dropdown">
//                 <div className="mobile-categories-header" onClick={() => setCategoriesOpen(!categoriesOpen)}>
//                   <span>All Categories</span>
//                   {categoriesOpen ? <IoChevronUp /> : <IoChevronDown />}
//                 </div>

//                 {categoriesOpen && (
//                   <div className="mobile-categories-list">
//                     {categories.map((cat, index) => (
//                       <div
//                         className="mobile-category-item"
//                         key={index}
//                         onClick={() => handleCategoryClick(cat)}
//                       >
//                         <img src={cat.image} alt={cat.name} className="mobile-category-icon" />
//                         <span>{cat.name}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {accessToken && (
//               <div className="mobile-user-actions">
//                 <div className="mobile-action" onClick={() => navigateTo('/whish')}>
//                   <FaRegHeart />
//                 </div>
//                 <div className="mobile-action" onClick={() => navigateTo('/Shopping_cart')}>
//                   <HiOutlineShoppingBag />
//                 </div>
//                 <div className="mobile-action" onClick={() => navigateTo('/user')}>
//                   <FaRegUser />
//                   <span>{username || 'Account'}</span>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Desktop Navigation */}
//         {!isMobile && (
//           <>
//             <div className="categories-dropdown" onClick={toggleCategories}>
//               <button className="categories-buttons">
//                 <div className="categories-icons">
//                   <span className="categories-icon-line"></span>
//                   <span className="categories-icon-line"></span>
//                   <span className="categories-icon-line"></span>
//                 </div>
//               </button>
//               <span className="categories-text">All Categories</span>

//               {shouldShowDropdown && (
//                 <IoChevronDown className={`down-line-categories ${categoriesOpen ? 'open' : ''}`} />
//               )}

//               {location.pathname === '/' ? (
//                 <div className="category-sidebar always-visible">
//                   {categories.map((cat, index) => (
//                     <div
//                       className="category-item-nav"
//                       key={index}
//                       onClick={() => handleCategoryClick(cat)}
//                     >
//                       <img src={cat.image} alt={cat.name} className="category-icon" />
//                       <span className="category-label">{cat.name}</span>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 categoriesOpen && (
//                   <div className="category-sidebar dropdown-visible" onClick={(e) => e.stopPropagation()}>
//                     {categories.map((cat, index) => (
//                       <div
//                         className="category-item-nav"
//                         key={index}
//                         onClick={() => handleCategoryClick(cat)}
//                       >
//                         <img src={cat.image} alt={cat.name} className="category-icon" />
//                         <span className="category-label">{cat.name}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )
//               )}
//             </div>

//             <div className="nav-bar-group  justify-content-center">
//               {['/', '/shop', '/blog', '/about', '/contact'].map((path) => (
//                 <div key={path} className="nav-bar" onClick={() => navigate(path)}>
//                   <span className={`nav-bar-text ${isActive(path) ? 'active' : 'inactive'}`}>
//                     {path === '/' ? 'MarketPlace' : path.replace('/', '').charAt(0).toUpperCase() + path.slice(2)} {/* Changed "Home" to "Market Place" */}
//                   </span>
//                 </div>
//               ))}

//               {accessToken && (
//                 <div className="icons-group">
//                   <div className="heart-icon" style={{ position: 'relative' }}>
//                     <FaRegHeart className='myheart' onClick={() => navigate('/whish')} />
//                     {wishlistCount > 0 && (
//                       <span className="wishlist-count" style={{
//                         position: 'absolute',
//                         top: '-8px',
//                         right: '-8px',
//                         backgroundColor: '#00b207',
//                         color: 'white',
//                         borderRadius: '50%',
//                         width: '20px',
//                         height: '20px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         fontSize: '12px',
//                         fontWeight: 'bold',
//                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                       }}>
//                         {wishlistCount}
//                       </span>
//                     )}
//                   </div>
//                   <div className="cart-icons">
//                     <ShoppingCartPopup isOpen={cartVisible} onClose={closeCart} />
//                     <HiOutlineShoppingBag className='mycart' onClick={toggleCart} />
//                     {totalItems > 0 && (<span className="cart-count" style={{
//                       position: 'absolute',
//                       top: '-8px',
//                       right: '-8px',
//                       backgroundColor: '#00b207',
//                       color: 'white',
//                       borderRadius: '50%',
//                       width: '20px',
//                       height: '20px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       fontSize: '12px',
//                       fontWeight: 'bold',
//                       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                     }}>{totalItems}</span>)}
//                   </div>
//                   <div className="user-icon" onClick={() => navigate('/user')}>
//                     <FaRegUser className='cc' />
//                   </div>

//                   {username && <span className="username-label" onClick={() => navigate('/user')}>{username}</span>}
//                 </div>
//               )}
//             </div>

//             {!accessToken && (<div className='navlogincontainer'>
//               <Link id='navloginbutton' className={`nav-bar-text  ${isActive("/login") ? 'active' : 'inactive'}`} to="/login">
//                 <TbLogin2 />Login
//               </Link>
//             </div>)
//             }
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// export default NavLinks;





import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './nav.css'; // Make sure this path is correct
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { FaRegHeart, FaRegUser } from "react-icons/fa";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import ShoppingCartPopup from '../Popup/popupcard';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { getWithoutTokenAPI, getWithTokenAPI } from '../../util/Api';
import { setWishlistCount, setWishlistItems } from '../../store/wishlistSlice';
import { setTotalItems } from '../../store/cartSlice';
import { toast } from 'react-toastify'; // Import toast for notifications

// Local category icons
import furit from '../../assets/navbar/apple.svg';
import Vegetables from '../../assets/navbar/salad 1.svg';
import fish from '../../assets/navbar/fish.svg';
import chicken from '../../assets/navbar/meat.svg';
import drink from '../../assets/navbar/coffee.svg';
import ice from '../../assets/navbar/ice-cream.svg';
import cake from '../../assets/navbar/cupcake.svg';
import butter from '../../assets/navbar/pie.svg';
import cook from '../../assets/navbar/food.svg';
import plus from '../../assets/navbar/plus-solid.svg';
import { Link } from "react-router-dom";
import { TbLogin2 } from "react-icons/tb";

const localCategoryImages = {
  'Fresh Fruit': furit,
  'Vegetables': Vegetables,
  'River Fish': fish,
  'Chicken & Meat': chicken,
  'Drink & Water': drink,
  'Yogurt & Ice Cream': ice,
  'Cake & Bread': cake,
  'Butter & Cream': butter,
  'Cooking': cook,
  'More': plus,
};

const getPageTitle = (pathname) => {
  switch (pathname) {
    case '/':
      return 'MarketPlace';
    case '/shop':
      return 'Shop';
    case '/blog':
      return 'Blog';
    case '/about':
      return 'About Us';
    case '/contact':
      return 'Contact Us';
    case '/privacy':
      return 'Privacy Policy';
    case '/terms':
      return 'Terms & Conditions';
    case '/faq':
      return 'FAQ';
    default:
      return 'Shambasync';
  }
};

const NavLinks = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [cartVisible, setCartVisible] = useState(false);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth?.auth?._id);
  const wishlistCount = useSelector((state) => state.wishlist.totalCount);
  const totalItems = useSelector((state) => state.cart.totalItems || 0);
  const username = useSelector((state) => state.auth?.auth?.name || '');
  const accessToken = useSelector((state) => state.auth?.auth?.access_token);

  const [categories, setCategories] = useState([]);
  const [remainingSubscriptionDays, setRemainingSubscriptionDays] = useState(null);
  console.log("remainingSubscriptionDays======", remainingSubscriptionDays)

  const isActive = (path) => location.pathname === path;

  const shouldShowDropdown = ['/shop', '/blog', '/about', '/contact', '/product', '/user', '/blog/find-particular', '/whish', '/Shopping_Cart'].includes(location.pathname);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (menuOpen && isMobile) {
      document.body.classList.add('scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [menuOpen, isMobile]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (!menuOpen) {
      setCategoriesOpen(false);
    }
  };

  const toggleCategories = () => {
    if (shouldShowDropdown) {
      setCategoriesOpen(!categoriesOpen);
    }
  };

  const navigateTo = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const toggleCart = () => setCartVisible(!cartVisible);
  const closeCart = () => setCartVisible(false);

  useEffect(() => {
    const fetchCategories = async () => {
      const result = await getWithoutTokenAPI("/category/find-all?Approval_status=Approval");
      if (result && !result.error && result.data?.categories) {
        const dataWithImages = result.data.categories.map((cat) => ({
          id: cat._id,
          name: cat.category_name,
          image: cat.image || localCategoryImages[cat.category_name] || plus,
        }));
        setCategories(dataWithImages);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchWishlistCount = async () => {
      if (!userId) return;

      try {
        const response = await getWithTokenAPI(accessToken, `/wishlist/find-all?user_id=${userId}`);
        if (response?.statusCode === 200) {
          dispatch(setWishlistCount(response.data.total_count));
          dispatch(setWishlistItems(response.data.wishlist));
        }
      } catch (error) {
        console.error('Error fetching wishlist:', error);
      }
    };

    fetchWishlistCount();
  }, [userId, dispatch, accessToken]);

  useEffect(() => {
    const fetchCartCount = async () => {
      if (!userId || !accessToken) return;
      try {
        const response = await getWithTokenAPI(accessToken, `/cart/find-all?user_id=${userId}`);

        if (response?.statusCode === 200 && response.data) {
          dispatch(setTotalItems(response.data?.Cart[0]?.cart?.length));
        }
      } catch (error) {
        console.error('Error fetching cart count:', error);
      }
    };

    fetchCartCount();
  }, [userId, dispatch, accessToken]);
  const truncateUsername = (name) => {
    if (name.length > 6) {
      return `${name.slice(0, 6)}...`;
    }
    return name;
  };


  useEffect(() => {
    const fetchSubscriptions = async () => {
      if (!userId || !accessToken) {
        setRemainingSubscriptionDays(null);
        return;
      }

      try {
        const response = await getWithTokenAPI(accessToken, `/subscription/find-all?user_id=${userId}`);

        // if (response.statusCode === 200 && response.data && Array.isArray(response.data.subscriber) && response.data.subscriber.length > 0) {
        //   const activeSubscription = response.data.subscriber[0];
        //   setRemainingSubscriptionDays(activeSubscription.remaining_days);
        // } else {
        //   setRemainingSubscriptionDays(0);
        // }
        if (
          response.statusCode === 200 &&
          response.data &&
          Array.isArray(response.data.subscriber) &&
          response.data.subscriber.length > 0 &&
          response.data.subscriber[0].paid_status &&
          response.data.subscriber[0].paid_status.trim() !== "" &&
          response.data.subscriber[0].paid_status !== "Failed"
        ) {
          const activeSubscription = response.data.subscriber[0];
          setRemainingSubscriptionDays(activeSubscription.remaining_days);
        } else {
          setRemainingSubscriptionDays(0);
        }
      } catch (err) {
        console.error("Error fetching subscriptions:", err);
        setRemainingSubscriptionDays(0);
        toast.error("Failed to load subscription status.");
      }
    };

    fetchSubscriptions();
  }, [userId, accessToken, toast]);

  const handleCategoryClick = (category) => {
    navigate(
      `/shop?category_id=${category.id}&category_name=${encodeURIComponent(category.name)}`,
      {
        state: {
          selectedCategoryId: category.id,
          selectedCategoryName: category.name
        }
      }
    );
    setMenuOpen(false);
    setCategoriesOpen(false);
  };

  return (
    <>
      {location.pathname === '/' ? (
        <Helmet>
          <title>MarketPlace</title>
          <meta name="description" content="Welcome to Shambasync - your go-to store for fresh food and more!" />
        </Helmet>
      ) : (
        <Helmet>
          <title>{`${getPageTitle(location.pathname)}`}</title>
          <meta name="description" content={`${getPageTitle(location.pathname)} page of Shambasync`} />
        </Helmet>
      )}
      <div className={`nav-bar-container ${location.pathname === '/' ? 'home-page' : ''}`}>
        {/* Mobile Hamburger Button */}
        <button className="mobile-menu-button" onClick={toggleMenu}>
          <div className="hamburger-icon">
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
          </div>
        </button>

        {/* Mobile Menu Content */}
        {menuOpen && (
          <div className="mobile-menu-content">
            <div className="mobile-nav-links">
              {['/', '/shop', '/blog', '/about', '/contact'].map((path) => (
                <div key={path} className="mobile-nav-item" onClick={() => navigateTo(path)}>
                  <span className={`text-light ${isActive(path) ? 'active' : ''}`}>
                    {path === '/' ? 'MarketPlace' : path.replace('/', '').charAt(0).toUpperCase() + path.slice(2)}
                  </span>
                </div>
              ))}

              {!accessToken && (<div className='navlogincontainer'>
                <Link id='navloginbutton' style={{ fontSize: "16px" }} className={`nav-bar-text ${isActive("/login") ? 'active' : 'inactive'}`} to="/login">
                  <TbLogin2 /> Login
                </Link>
              </div>)}


              <div className="mobile-categories-dropdown">
                <div className="mobile-categories-header" onClick={() => setCategoriesOpen(!categoriesOpen)}>
                  <span>All Categories</span>
                  {categoriesOpen ? <IoChevronUp /> : <IoChevronDown />}
                </div>

                {categoriesOpen && (
                  <div className="mobile-categories-list">
                    {categories.map((cat, index) => (
                      <div
                        className="mobile-category-item"
                        key={index}
                        onClick={() => handleCategoryClick(cat)}
                      >
                        <img src={cat.image} alt={cat.name} className="mobile-category-icon" />
                        <span>{cat.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {accessToken && (
              <div className="mobile-user-actions">
                <div className="mobile-action" onClick={() => navigateTo('/whish')}>
                  <FaRegHeart />
                </div>
                <div className="mobile-action" onClick={() => navigateTo('/Shopping_cart')}>
                  <HiOutlineShoppingBag />
                </div>
                {/* Mobile User and Subscription */}
                <div className="mobile-action user-and-subscription-mobile">
                  <div className="user-info-mobile" onClick={() => navigateTo('/user')}>
                    <FaRegUser />
                    <span>{username || 'Account'}</span>
                  </div>
                  {userId && remainingSubscriptionDays !== null && (
                    <div className="subscription-status-text mobile-subscription-text">
                      {remainingSubscriptionDays > 0 ? (
                        <span>({remainingSubscriptionDays} days left)</span>
                      ) : (
                        <span className="not-subscribed-text">(Yet to subscribe)</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Desktop Navigation */}
        {!isMobile && (
          <>
            <div className="categories-dropdown" onClick={toggleCategories}>
              <button className="categories-buttons">
                <div className="categories-icons">
                  <span className="categories-icon-line"></span>
                  <span className="categories-icon-line"></span>
                  <span className="categories-icon-line"></span>
                </div>
              </button>
              <span className="categories-text">All Categories</span>

              {shouldShowDropdown && (
                <IoChevronDown className={`down-line-categories ${categoriesOpen ? 'open' : ''}`} />
              )}

              {location.pathname === '/' ? (
                <div className="category-sidebar always-visible">
                  {categories.map((cat, index) => (
                    <div
                      className="category-item-nav"
                      key={index}
                      onClick={() => handleCategoryClick(cat)}
                    >
                      <img src={cat.image} alt={cat.name} className="category-icon" />
                      <span className="category-label">{cat.name}</span>
                    </div>
                  ))}
                </div>
              ) : (
                categoriesOpen && (
                  <div className="category-sidebar dropdown-visible" onClick={(e) => e.stopPropagation()}>
                    {categories.map((cat, index) => (
                      <div
                        className="category-item-nav"
                        key={index}
                        onClick={() => handleCategoryClick(cat)}
                      >
                        <img src={cat.image} alt={cat.name} className="category-icon" />
                        <span className="category-label">{cat.name}</span>
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>

            <div className="nav-bar-group justify-content-center">
              {['/', '/shop', '/blog', '/about', '/contact'].map((path) => (
                <div key={path} className="nav-bar" onClick={() => navigate(path)}>
                  <span className={`nav-bar-text ${isActive(path) ? 'active' : 'inactive'}`}>
                    {path === '/' ? 'MarketPlace' : path.replace('/', '').charAt(0).toUpperCase() + path.slice(2)}
                  </span>
                </div>
              ))}

              {accessToken && (
                <div className="icons-group">
                  <div className="heart-icon" style={{ position: 'relative' }}>
                    <FaRegHeart className='myheart' onClick={() => navigate('/whish')} />
                    {wishlistCount > 0 && (
                      <span className="wishlist-count" style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        backgroundColor: '#00b207',
                        color: 'white',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        {wishlistCount}
                      </span>
                    )}
                  </div>
                  <div className="cart-icons">
                    <ShoppingCartPopup isOpen={cartVisible} onClose={closeCart} />
                    <HiOutlineShoppingBag className='mycart' onClick={toggleCart} />
                    {totalItems > 0 && (<span className="cart-count" style={{
                      position: 'absolute',
                      top: '-8px',
                      right: '-8px',
                      backgroundColor: '#00b207',
                      color: 'white',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>{totalItems}</span>)}
                  </div>

                  {/* Desktop User and Subscription */}
                  <div className="user-profile-group d-flex gap-3">
                    <div className="user-icon" onClick={() => navigate('/user')}>
                      <FaRegUser className='cc' />
                    </div>
                    <div className='mt-1'>
                      {username && <span className="username-label " onClick={() => navigate('/user')}> {truncateUsername(username)}</span>}

                    </div>

                    {/* {userId && remainingSubscriptionDays !== null && (
                      <div className="subscription-status-text desktop-subscription-text mt-1">
                        {remainingSubscriptionDays > 0 ? (
                          <span style={{ color: "white" }}>({remainingSubscriptionDays} days left)</span>
                        ) : (
                          <span className="not-subscribed-text" style={{ color: "white" }}>(Yet to subscribe)</span>
                        )}
                      </div>
                    )} */}

                  </div>
                </div>
              )}
            </div>

            {!accessToken && (<div className='navlogincontainer'>
              <Link id='navloginbutton' className={`nav-bar-text ${isActive("/login") ? 'active' : 'inactive'}`} to="/login">
                <TbLogin2 />Login
              </Link>
            </div>)
            }
          </>
        )}
      </div>
    </>
  );
};

export default NavLinks;